module.exports = __webpack_public_path__ + "js/stellarium-web-engine.2b3cab75.wasm";